import React from "react";
import HelmetComponent from "./HelmetComponent";

function TermsOfService(props) {
  return (
    <div className=" min-h-screen flex flex-col justify-between">
      <HelmetComponent
        title="Akerayu | Terms of Use"
        description=" Akerayu Terms of Use Updated May 20, 2024 1. Akerayu's Role Akerayu acts solely as a platform for landlords to list their properties and [...] Read More..."
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/terms-of-use"
        type="website"
        robots="index, follow"
      />

      <div className="w-7/12 max-sm:w-full m-auto">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold mb-4 text-main-orange">
            Akerayu Terms of Use
          </h1>
          <p className="mb-4">Updated May 20, 2024</p>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">1. Akerayu's Role</h2>
            <p>
              Akerayu acts solely as a platform for landlords to list their
              properties and for tenants to search for properties. Akerayu does
              not participate in the transactions between landlords and tenants,
              nor does it manage properties or handle any financial
              transactions.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              2. Eligibility; Accounts and Registration
            </h2>
            <p>
              You must be eligible to use Akerayu in accordance with the laws of
              your jurisdiction. Registration for an account on Akerayu may be
              required for certain services.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              3. Use of the Services; Restrictions
            </h2>
            <p className="mb-2">
              <span className="font-semibold">A. Use of the Services:</span> By
              using Akerayu, you agree to abide by these Terms of Use and all
              applicable laws and regulations.
            </p>
            <p className="mb-2">
              <span className="font-semibold">B. Mobile Applications:</span>{" "}
              Certain features of Akerayu may be accessible via mobile
              applications. Your use of such applications is subject to these
              Terms of Use.
            </p>
            <p className="mb-2">
              <span className="font-semibold">C. Use of Content:</span> The
              content available on Akerayu, including but not limited to
              property listings, text, images, and other materials, is provided
              for informational purposes only and may not be used for any other
              purpose without prior written consent.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">4. Prohibited Use</h2>
            <p>
              You are prohibited from using Akerayu for any unlawful or
              unauthorized purpose, including but not limited to:
            </p>
            <ul className="list-disc list-inside">
              <li>Violating any applicable laws or regulations;</li>
              <li>
                Interfering with or disrupting the operation of Akerayu or its
                servers;
              </li>
              <li>
                Impersonating any person or entity, or falsely stating or
                misrepresenting your affiliation with a person or entity;
              </li>
              <li>
                Attempting to gain unauthorized access to any portion or feature
                of Akerayu or its related systems or networks.
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              5. Intellectual Property
            </h2>
            <p>
              All intellectual property rights associated with Akerayu,
              including but not limited to trademarks, logos, service marks, and
              copyrighted materials, are the property of Akerayu or its
              licensors. You may not use, reproduce, distribute, or modify any
              such intellectual property without prior written consent.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">6. Feedback</h2>
            <p>
              If you provide Akerayu with any feedback or suggestions regarding
              the website or its services, you hereby grant Akerayu a perpetual,
              irrevocable, royalty-free license to use, modify, and incorporate
              such feedback into its products and services without any
              obligation to you.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">7. No Warranties</h2>
            <p>
              Akerayu provides the website and its services on an "as is" and
              "as available" basis, without any warranties of any kind, whether
              express or implied. Akerayu makes no representations or warranties
              regarding the accuracy, reliability, or completeness of any
              content available on the website.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              8. Limitation of Liability/Exclusive Remedy
            </h2>
            <p>
              In no event shall Akerayu or its affiliates be liable for any
              direct, indirect, incidental, special, or consequential damages
              arising out of or in any way connected with your use of Akerayu or
              its services, even if Akerayu has been advised of the possibility
              of such damages. Your sole and exclusive remedy for any dispute
              with Akerayu is to discontinue your use of the website.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">9. Links</h2>
            <p>
              Akerayu has not reviewed all of the sites linked to its website
              and is not responsible for the contents of any such linked site.
              The inclusion of any link does not imply endorsement by Akerayu of
              the site. Use of any such linked website is at the user's own
              risk.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              10. Consent to Communications
            </h2>
            <p>
              By using Akerayu, you consent to receive electronic communications
              from us, including but not limited to emails, messages, and
              notifications. These communications may include promotional
              materials, updates, and other information relevant to your use of
              the website.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              11. Site Terms of Use Modifications
            </h2>
            <p>
              Akerayu may revise these terms of use for its website at any time
              without notice. By using this website, you are agreeing to be
              bound by the then current version of these Terms of Use.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">12. Governing Law</h2>
            <p>
              Any claim relating to Akerayu shall be governed by the laws of
              Ethiopia without regard to its conflict of law provisions.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              13. Contact Information
            </h2>
            <p>
              If you have any questions or concerns regarding these Terms of
              Use, you may contact us. Contact Akerayu Support.
            </p>
          </div>

          <p className="mb-4">
            By using Akerayu, you acknowledge that you have read and understood
            these terms and conditions and agree to be bound by them.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
